/**
 * Created by litao on 2018/10/8.
 */
export default (http) => {
    return {


        /**
         * 查询字典列表
         * @param data
         * @return {*}
         */
        query(data) {
            return http.json({
                url: `order/strategry/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            })
        },

        queryAll (data){
            return http.json({
                url: '/order/strategry/queryAll',
                data
            })
        },

        queryAllStrategryItem(data){
            return http.json({
                url: '/order/strategry/item/queryAll',
                data
            })
        },


        /**
         * 查询活动详情
         */
        getInfo(data) {
            return http({
                url: `order/strategry/get?id=${data.id}`,
                method: 'post'
            });
        },


        /**
         * 保存活动
         */
        saveInfo(data) {
            return http.json({
                url: 'order/strategry/save',
                data
            })
        },


        /**
         * @param data
         * @return {*}
         */
        remove(data) {
            return http.json({
                url: '/order/strategry/delete',
                data
            })
        },

        /**
         * 发布
         * @param data
         * @return {*}
         */
        publish(data) {
            return http({
                url: `/order/strategry/publish?id=${data.id}`,
                method: 'post'
            })
        },

        /**
         * 取消发布
         * @param data
         * @return {*}
         */
        unPublish(data) {
            return http({
                url: `/order/strategry/unPublish?id=${data.id}`,
                method: 'post'
            })
        },








    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/strategry.js